import React, { useEffect, useState } from "react";
import { Sun, Moon, Laptop } from "lucide-react";
import { getTheme, setTheme } from "@/lib/theme";

/**
 * Iter-191 · ThemeToggle · 3-way segmented control (Light / System / Dark).
 * Purely theme-var driven so it works on every page (admin, tenant, public).
 * `variant="compact"` renders a tighter version for topbars / login corners.
 */
export default function ThemeToggle({ className = "", variant = "default" }) {
  const [t, setT] = useState(() => getTheme());
  useEffect(() => {
    const on = () => setT(getTheme());
    window.addEventListener("themechange", on);
    return () => window.removeEventListener("themechange", on);
  }, []);
  const pick = (mode) => { setTheme(mode); setT(mode); };
  const compact = variant === "compact";
  const btn = (mode, Icon, label) => (
    <button type="button" aria-label={label} title={label}
      data-testid={`theme-${mode}`}
      onClick={() => pick(mode)}
      className={[
        "flex items-center justify-center transition-colors rounded-sm",
        compact ? "w-7 h-7" : "w-8 h-8",
        t === mode
          ? "bg-foreground/10 text-foreground"
          : "text-foreground/50 hover:text-foreground hover:bg-foreground/5",
      ].join(" ")}>
      <Icon className={compact ? "w-3.5 h-3.5" : "w-4 h-4"} />
    </button>
  );
  return (
    <div data-testid="theme-toggle"
      className={`inline-flex items-center gap-0.5 border border-foreground/15 rounded-sm bg-background/60 p-0.5 ${className}`}>
      {btn("light",  Sun,    "Light theme")}
      {btn("system", Laptop, "System theme")}
      {btn("dark",   Moon,   "Dark theme")}
    </div>
  );
}
